module.exports = __webpack_public_path__ + "engineering.1_o8Byjq.svg";